import _ from 'lodash'
import {
  PROCESS_WHITELIST_FIELD_TYPE,
  PROCESS_WHITELIST_FRIENDLY_FIELD,
  PROCESS_VALUE_HELP_TEXT
} from '@/constants/rules.constants'
import RuleWhitelist from '@/resources/models/allowlist/RuleWhitelist'

function validateProcessValue (rule, value, callback) {
  if (!value || !value.length) {
    callback(new Error('Please provide the whitelist value.'))
  } else {
    callback()
  }
}

export default class ProcessRuleWhitelist extends RuleWhitelist {
  constructor (uuid = null, attributes = {}, options = {}) {
    super(uuid, attributes, options)
    this.field = PROCESS_WHITELIST_FIELD_TYPE
    this.friendlyFieldName = PROCESS_WHITELIST_FRIENDLY_FIELD
    this.valueHelpText = PROCESS_VALUE_HELP_TEXT
    this.validationRules.value[0].validator = validateProcessValue
  }
}



// WEBPACK FOOTER //
// ./src/resources/models/allowlist/ProcessRuleWhitelist.js